var pt_br = {
    values: {
        'reports approval': 'Aprovação de Relatórios',
        'Error trying to save the approval settings': 'Erro ao tentar salvar as configurações de aprovação: ',
        'Search for a report approval': 'Procure um relatório para aprovação',

        // Table Header
        'Report Name': 'Nome do Relatório',
        'Schedule Name': 'Nome do Agendamento',
        'Alarm Rule': 'Regra de Alarme',
        Asset: 'Ativo',
        Timespan: 'Intervalo de tempo',
        'Data Status': 'Status dos Dados',
        'Sending Status': 'Status de Envio',

        'Check data': 'Verificar dados',
        'Send report': 'Enviar relatório',

        // Check and Send Modal
        approvalListCheckDataMessage:
            'Esta ação carregará os Dados Estáticos de Entrada em uma nova aba do navegador, com os relatórios Rig e Timespan. Também registrará a data, hora e responsável pela verificação dos dados na Aprovação de Relatórios.',
        approvalListUndoneAlertMessage: 'Esta ação não pode ser desfeita.',
        approvalListSendDataMessage: 'Esta ação atualizará a data, hora e o responsável pelo envio do relatório.',
        approvalListCheckDataTitle: 'Verificar Dados',
        approvalListSendDataTitle: 'Atenção!',
        confirmCheckDataButton: 'Ir para a verificação de dados',
        confirmSendDataButton: 'Enviar dados',

        'Server local time': 'Hora local do servidor: ',
        Unchecked: 'Não verificado',
        'Dashboard not found': 'Gráfico não encontrado',
        'Data checked on': 'Dados verificados em ',
        'Checked by': ' Verificado por ',
        'Not sent': 'Não enviado',
        'Last sent on': 'Último envio em ',
        'Sent by': ' Enviado por '
    }
}

module.exports = pt_br
